import { render, staticRenderFns } from "./PerDish.vue?vue&type=template&id=96e8260c&"
import script from "./PerDish.vue?vue&type=script&lang=js&"
export * from "./PerDish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports